import { render } from "./setup.vue?vue&type=template&id=d6358b8a&scoped=true"
import script from "./setup.vue?vue&type=script&lang=js"
export * from "./setup.vue?vue&type=script&lang=js"

import "./setup.vue?vue&type=style&index=0&id=d6358b8a&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-d6358b8a"

export default script